// extracted by mini-css-extract-plugin
export default {"workspace":"ViewerBody_workspace__N3Ha2","container":"ViewerBody_container__r8P+x","containerShift":"ViewerBody_containerShift__ZukKk","page":"ViewerBody_page__U7PIl"};